import React from "react";

const COVERAGES = [
  "General Liability",
  "Workers Comp",
  "Auto",
  "Commercial",
  "Homeowners",
  "Umbrella",
  "Cyber Liability",
  "Earthquake",
  "Flood",
  "Life",
  "Disability",
  "Renters",
  "Professional Liability",
  "Commercial Auto",
  "BOP",
  "Boat & RV",
  "Landlord",
  "Pollution",
];

export default function Carriers() {
  // Repeat list to make the marquee seamless
  const items = [...COVERAGES, ...COVERAGES];

  return (
    <section
      data-testid="section-carriers"
      aria-label="Coverage types"
      className="bg-white border-t border-neutral-200"
    >
      <div className="py-10 md:py-12 overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 mb-6 flex items-center justify-between">
          <div className="text-xs uppercase tracking-[0.22em] text-neutral-500">
            Coverage that covers everything
          </div>
          <div className="hidden md:block text-xs uppercase tracking-[0.22em] text-neutral-400">
            Independent
          </div>
        </div>

        <div
          className="relative"
          style={{
            maskImage:
              "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
          }}
        >
          <div className="marquee-track flex w-max gap-14 md:gap-20">
            {items.map((c, i) => (
              <div
                key={`${c}-${i}`}
                className="font-display text-2xl md:text-3xl lg:text-4xl font-semibold tracking-[-0.02em] text-neutral-300 hover:text-black transition-colors whitespace-nowrap"
                aria-hidden={i >= COVERAGES.length}
              >
                {c}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
